module.exports = "https://trybtryb-legacy.web.app/img/sandstorm.2572adb9.webp";